module.exports = new __parcel__URL__("image_en.7f7f893e.png").toString();